export const environment = {
  production: false,
  authority: 'https://signin.test-connect.aveva.com',
  clientId: 'sixb06fbPgKK7cgD51lrgg3zeebpxuHJ',
  singleSignOutUrl: 'https://profile.test-connect.aveva.com/singlesignout',
  sessionExpiredUrl: 'https://profile.test-connect.aveva.com/sessionexpired',
  connect: 'https://test-connect.aveva.com',
  appInsightsConnectionString: 'U2FsdGVkX1/ALL78mopA/TV3Y5I+MsOn/BEQLTsFbp286VEio5cUct1/YTqorcQ35C4+VERNduRcLGr6joHV1+MI/mznzQdiaDMc9H3g1NoPr7d93nPIBUmQ0sd1dWNOdC7EB4CKQwoylzEhPa9WqrT4QWDQqDUlYySQHCLKY7xmzRIafIMyEtShKY/w9FMa53v59S483PYnH/Kx1XmF6VzhB2vNFLToAqTHeWUgcjT5BOSTS6YRXUWdGODPWL8UvktIcDe0dEvUCUZKcwsp9OZMh8qAr4XABjcILnfvQbYkpb9Phn3Ri5nS47X3jpOLwf/fZg+5LdkKpHjsdks2wg==',
  apis: {
    am: 'https://api.test-connect.aveva.com/am',
    registry: 'https://api.test-connect.aveva.com/registry',
    uam: 'https://services.test-connect.aveva.com/uam/v2',
    scm: 'https://api.test-connect.aveva.com/scm',
    logging: 'https://api.test-connect.aveva.com/logging',
    assets: 'https://api.test-connect.aveva.com/assets',
    connect: 'https://connectapi.tc.test-connect.aveva.com',
    cds: 'https://cdsapi.tc.test-connect.aveva.com'
  }
};
